// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27FWp","name":"styles_name__3mQe2","phone":"styles_phone__2OwW0"};